import { z } from 'zod/v4';

export const retiredFormSchema = z.object({
  kind: z.literal('retired'),
});

type RetiredFormValues = z.infer<typeof retiredFormSchema>;

export const defaultRetiredFormValues: RetiredFormValues = {
  kind: 'retired',
};

// There is no need for a component for the retired form, because it has no additional fields
